export const updateSearchParam = (url: URL, param: string, value: string) => {
  if (url && param && value) {
    url.searchParams.set(param, value)
    window.history.replaceState({}, '', url.toString())
  }
}
